export const FileIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M7.88576 1.76074C8.68364 1.76077 9.43339 2.13751 9.91132 2.77393L10.6234 3.72201L10.7023 3.81396C10.8971 4.01778 11.1677 4.13541 11.4535 4.13623H13.6621C15.1825 4.13623 16.3971 4.5255 17.203 5.46924C17.9856 6.38577 18.2503 7.67633 18.2503 9.16553V9.1696L18.2284 13.049C18.2276 14.5921 17.7694 15.9119 16.8351 16.8462C15.9001 17.7812 14.579 18.2394 13.0339 18.2394H6.95396C5.40598 18.2394 4.08291 17.781 3.14618 16.8462C2.20928 15.9112 1.74969 14.5901 1.74969 13.0449V6.95117C1.74969 5.48742 2.01433 4.17274 2.7759 3.21663C3.56601 2.22484 4.77301 1.76074 6.32326 1.76074H7.88576ZM3.25035 13.0449C3.25035 14.2954 3.61652 15.1969 4.20575 15.785C4.79518 16.3731 5.69917 16.7396 6.95396 16.7396H13.0339C14.2851 16.7396 15.1869 16.373 15.7748 15.785C16.3625 15.197 16.7285 14.2956 16.7285 13.0449V13.0409L16.7497 9.16553L16.7383 8.67806C16.684 7.59539 16.443 6.88946 16.062 6.44336C15.6499 5.96073 14.9447 5.63688 13.6621 5.63688H11.4494C10.6538 5.63459 9.90528 5.25963 9.42629 4.62451L9.42548 4.6237L8.71177 3.6748C8.51607 3.4142 8.21001 3.26142 7.88576 3.26139H6.32326C5.0772 3.26139 4.37172 3.62087 3.9494 4.15088C3.49868 4.71666 3.25035 5.62262 3.25035 6.95117V13.0449Z"
        fill="#282828"
      />
      <path
        d="M13.7321 11.3037L13.8094 11.3078C14.1875 11.3463 14.4824 11.6658 14.4824 12.054C14.4824 12.4423 14.1875 12.7618 13.8094 12.8003L13.7321 12.8044H6.23696C5.82275 12.8044 5.48663 12.4683 5.48663 12.054C5.48663 11.6398 5.82275 11.3037 6.23696 11.3037H13.7321Z"
        fill="#282828"
      />
    </svg>
  );
};
